export default __webpack_public_path__ + "a165f31f4506fa9b07f0f2319dd58aa0.png";